<template>
   <div class="mx-auto">
     <PaymentDetailSCT   v-if="params.methodTypeId === 2"       :params='params' @confirm="onCollectDetails" @abort="$emit('abort')"/>
     <PaymentDetailSWIFT v-else-if="params.methodTypeId === 5"  :params='params' @confirm="onCollectDetails" @abort="$emit('abort')"/>
   </div>
</template>

<script>
// import { VCard } from 'vuetify/lib'
import PaymentDetailSCT from '@/views/payment/views/desktop/PaymentDetailSCT'
import PaymentDetailSWIFT from '@/views/payment/views/desktop/PaymentDetailSWIFT'

export default {
  name: 'PaymentDetail',
  components: { PaymentDetailSCT, PaymentDetailSWIFT },
  props: {
    params: {
      type: Object,
      default: () => ({})
    },
    origin: {
      type: String,
      default: ''
    }
  },
  created: function () {
    this.stopLoader()
    if (this.needInput.indexOf(this.params.methodTypeId) === -1) this.$emit('paymentDetail', {})
  },
  methods: {
    onCollectDetails (data) {
      this.$emit('paymentDetail', data)
    },
    stopLoader () {
      this.$emit('stopLoader')
    }
  },
  data () {
    return {
      needInput: [ 2, 5 ]
    }
  }
}
</script>
